import { updateSchedule, updateSelectedChannel } from "./Schedule";
import { loadStoryByBmmrId } from "./Video";

const PageActions = {
    refreshPageData({ streamChannelId, selectedChannelId }) {
        return (dispatch) => {
            dispatch(updateSchedule(streamChannelId));

            if (streamChannelId !== selectedChannelId) {
                dispatch(updateSchedule(selectedChannelId));
            }
        };
    },

    refreshCoJPPageData({ streamChannelId, selectedChannelId }) {
        return (dispatch) => {
            dispatch(updateSchedule(streamChannelId));

            if (streamChannelId !== selectedChannelId) {
                dispatch(updateSchedule(selectedChannelId));
            }
        };
    },

    onPlaylistContinuousPlay(bmmrId) {
        return loadStoryByBmmrId(bmmrId, { isContinuousPlay: true });
    },

    updateLiveBarByChannelId(channelId) {
        return (dispatch) => {
            dispatch(updateSelectedChannel(channelId));
            dispatch(updateSchedule(channelId));
        };
    },
};

export default PageActions;

export const {
    refreshPageData,
    refreshCoJPPageData,
    onPlaylistContinuousPlay,
    updateLiveBarByChannelId,
} = PageActions;
